import type * as React from 'react';
import { post } from '@Domain/Api';
import organizationWorkflowCreated, {
	type OrganizationWorkflowCreatedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowCreated';
import organizationWorkflowCreationFailed, {
	type OrganizationWorkflowCreationFailedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowCreationFailed';
import type { OrganizationWorkflowPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';
import type SaveOrganizationWorkflow from '@Application/Organizations/Workflows/Commands/SaveOrganizationWorkflow';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationWorkflowCreatedAction | OrganizationWorkflowCreationFailedAction;

/** Creates a new group: the command's `workflowKey` is ignored, the server derives the key from the label. */
export default (command: SaveOrganizationWorkflow) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await post<OrganizationWorkflowPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/workflows`,
				command.toJSON(),
			);

			const action = organizationWorkflowCreated(response, command.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationWorkflowCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
